import { UseMeasurementResponse } from "@/types/measurement/measurement";
import { sortBy } from "es-toolkit/compat";

const selectBodyMeasurement = (data: UseMeasurementResponse) => {
  const { measurements = [] } = data;
  const bodyData = sortBy(measurements.map((measurement) => ({
    date: new Date(Number(measurement.timestamp)),
    value: Number(measurement.meta?.value) || 0,
  })), ["date"]);
  const current = bodyData[bodyData.length - 1]?.value || 0;
  const previous = bodyData[bodyData.length - 2]?.value || 0;
  const change = bodyData.length >= 1 ? current - previous : 0;
  return { data: bodyData, current, change, previous };
};

export default selectBodyMeasurement;
